import { Component, ElementRef, inject, ViewChild } from "@angular/core";
import { FloatingAssistantChatService } from "src/app/common/services/floating-assistant-chat.service";

@Component({
  templateUrl: "./drop-list.component.html",
  selector: "app-drop-list",
  styleUrls: ["./drop-list.component.scss"],
})
export class DropListComponent {
  protected readonly floatingAssistantChatService = inject(FloatingAssistantChatService);
  @ViewChild("scrollableRef") scrollableRef!: ElementRef;

  removeItem(id: string): void {
    this.floatingAssistantChatService.removeMedia(id);
  }

  async drop(): Promise<void> {
    // wait 5s dragged item is fully loaded
    let maxTry = 20;
    while (!this.floatingAssistantChatService.draggedItem && maxTry > 0) {
      maxTry--;
      await this.sleep(200);
    }
    this.floatingAssistantChatService.addMedia();
    setTimeout(() => {
      this.scrollableRef.nativeElement.scrollTop = this.scrollableRef.nativeElement.scrollHeight;
    }, 0);
  }

  async sleep(ms: number): Promise<void> {
    await new Promise((resolve) => {
      setTimeout(resolve, ms);
    });
  }
}
